import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-view-route-dialog',
  templateUrl: './view-route-dialog.component.html',
  styleUrls: ['./view-route-dialog.component.css'],
  host: { 'class': 'app-view-route-dialog'}
})
export class ViewRouteDialogComponent implements OnInit {

  constructor(private dialog: MatDialog,
    public dialogRef: MatDialogRef<ViewRouteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/user-dashboard/view-route-dialog/view-route-dialog.component.ts